// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoSubtitles-modulewrapper1fz","textWrapper":"VideoSubtitles-moduletextWrapper1Q9"};